import React from 'react';
import { Button, Snackbar, SnackbarProps } from "@mui/material";
import { Alert } from '@mui/material';
import { SnackbarCloseReason } from "@mui/material/Snackbar/Snackbar";

export interface DataLoadErrorSnackBarProps extends Omit<SnackbarProps, "onClose"> {
    onClose?: () => void;
}

export default function ErrorSnackBar(props: DataLoadErrorSnackBarProps): JSX.Element {
    const {
        onClose,
        message = "Failed to load data!",
        ...other
    } = props;

    const handleClose = (event: React.SyntheticEvent<any> | Event, reason?: SnackbarCloseReason) => {
        if (onClose === undefined || reason === 'clickaway') {
            return;
        }

        onClose();
    };

    return (
        <Snackbar
            onClose={handleClose}
            {...other}
        >
            <Alert
                elevation={6}
                onClose={handleClose}
                variant="filled"
                severity="error"
                action={
                    <Button onClick={handleClose} color="inherit" size="small">
                        ACKNOWLEDGE
                    </Button>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );
}

